<div class="clearFilters">
    <button class="tertiary-btn" [disabled]="disabledClearFiltersBtn$ | async" (click)="onClearAllFilters()">
        Clear filters
    </button>
</div>
